import styled from 'styled-components';

export const NavbarWrap = styled.ul `
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
`; 